import React from "react";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import ReactDOM from "react-dom";
import useAuth from "../hooks/useAuth";

function EditOrganMenuModal(props) {
  const { modal, setModal, id, materials, onMaterialsUpdated } = props;
  const { user } = useAuth();
  const [dragIndex, setDragIndex] = useState(null);
  const [materialsUI, setMaterialsUI] = useState([]);

  useEffect(() => {
    if (modal) {
      setMaterialsUI(materials);
    }
  }, [modal]);

  const handleDragStart = (e, index) => {
    setDragIndex(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // REQUIRED
  };

  const handleDrop = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) return;

    const updated = [...materialsUI];
    const [movedItem] = updated.splice(dragIndex, 1);
    updated.splice(dropIndex, 0, movedItem);

    setMaterialsUI(updated);
    setDragIndex(null);
  };
  const updateDisplayName = (i, value) => {
    setMaterialsUI((prev) =>
      prev.map((item, idx) =>
        idx === i ? { ...item, displayName: value } : item
      )
    );
  };

  const handleSubmit = async () => {
    const materialConfig = materialsUI.map((m, order) => ({
      originalName: m.originalName,
      displayName: m.displayName,
      order,
    }));

    const payload = {
      _id: id,
      materials: materialConfig.length ? materialConfig : undefined,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/update-glb-model-material`,
      payload
    );

    // ✅ FIX: read from response.data
    await onMaterialsUpdated(response.data.materials);

    setModal({ show: false, id: null });
  };
  return ReactDOM.createPortal(
    <React.Fragment>
      <div
        className={"modal fade " + (props.modal ? "show " : "")}
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={props.modal ? { display: "block" } : { display: "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold" id="exampleModalLabel">
                Edit Material
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  props.setModal(false);
                }}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h5 className="fw-bold mb-2">Materials</h5>

                <div className="border rounded p-2" style={{ maxHeight: "450px", overflowY: "auto" }}>
                  {materialsUI.map((item, i) => (
                    <div
                      key={item.originalName + i}
                      draggable
                      onDragStart={(e) => handleDragStart(e, i)}
                      onDragOver={handleDragOver}
                      onDrop={() => handleDrop(i)}
                      className="d-flex align-items-center gap-4 mb-2 p-2 border rounded bg-white"
                      style={{ cursor: "grab" }}
                    >
                      <span className="text-muted">☰</span>
                      <span className="badge bg-secondary">{i + 1}</span>

                      <span className="text-muted small" style={{ minWidth: "200px" }}>
                        {item.originalName}
                      </span>

                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={item.displayName}
                        onChange={(e) => updateDisplayName(i, e.target.value)}
                      />
                    </div>
                  ))}
                </div>

                <button
                  type="button"
                  className="btn btn-primary w-100 mt-3"
                  onClick={handleSubmit}
                >
                  Save Material
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {props.modal ? <div className="modal-backdrop fade show" /> : ""}
    </React.Fragment>,
    document.getElementById("modal-root")
  );
}
export default EditOrganMenuModal;
